module.exports = __webpack_public_path__ + "static/media/koi_princess.netent.8ac366b1.jpeg";